import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { BodyText, Button, IllusEmployeeBag, Image, theme } from '@sg/garnish';

import { useNavigateToLastInteractedStore } from '../../../context';

export const OrdersEmptyState = () => {
  const { formatMessage } = useIntl();
  const navigateToLastInteractedStore = useNavigateToLastInteractedStore();

  return (
    <View style={styles.container}>
      <Image
        source={IllusEmployeeBag}
        style={styles.image}
        aria-label={formatMessage(messages.emptyIllustrationAlt)}
      />

      <View style={styles.content}>
        <BodyText sizeMatch={['14', '16']} bold style={styles.text}>
          <FormattedMessage {...messages.title} />
        </BodyText>

        <BodyText sizeMatch={['14', '16']} style={styles.text}>
          <FormattedMessage {...messages.subtitle} />
        </BodyText>

        <Button
          size="large-wide"
          palette="kaleLightest"
          accessibilityRole="link"
          accessibilityLabel={formatMessage(messages.cta)}
          onPress={navigateToLastInteractedStore}
        >
          <FormattedMessage {...messages.cta} />
        </Button>
      </View>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'No history',
    description: 'Account | Orders | Title',
  },
  subtitle: {
    defaultMessage: 'You will see your order history here.',
    description: 'Account | Orders | Subtitle',
  },
  cta: {
    defaultMessage: 'Order now',
    description: 'Account | Orders | CTA',
  },
  emptyIllustrationAlt: {
    defaultMessage: 'A person holding a Sweetgreen bag',
    description: 'Account | Orders | Alt text for empty state illustration',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginVertical: theme.spacing['12'],
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    gap: theme.spacing['6'],
  },
  image: {
    width: 220,
    height: 220,
    marginBottom: theme.spacing['4'],
  },
  text: {
    textAlign: 'center',
  },
});
